import toast from 'react-hot-toast';

export const notify = (text, type , time = 1700) => {

    if (type === "succ") {

        return toast.success(text, {

            duration: time,
            position: 'top-left',
            className: '',
            style: {
                padding: '10px',
                color: '#fff',
                backgroundColor: "#069e15"
            },
        })

    }
    else if (type === "error") {

        return toast.error(text, {

            duration: time,
            position: 'top-left',
            className: '',
            style: {
                padding: '10px',
                color: '#fff',
                backgroundColor: "#e3242b"
            },
        });
    }



}